export default __webpack_public_path__ + "static/media/microart.7e982535.png";